<template>
  <div>
      <footer class="footer section section-sm">
  <!-- Container Start -->
  <div class="container">
    <div class="row">
      <!-- <div class="col-lg-3 col-md-7 offset-md-1 offset-lg-0">
        
        <div class="block about">
         
          <img src="images/logo-footer.png" alt="">
          
          <p class="alt-color text-secondary">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
        </div>
         <ul class="social-media-icons mb-3">
              <li><a class="fa fa-facebook" href=""></a></li>
              <li><a class="fa fa-twitter" href=""></a></li>
              <li><a class="fa fa-pinterest-p" href=""></a></li>
              <li><a class="fa fa-vimeo" href=""></a></li>
            </ul>
      </div> -->
      <!-- Link list -->
      <!-- <div class="col-sm-6  offset-lg-1 col-md-3">
        <div class="block block-link">
          <h4>Site Pages</h4>
          <ul>
            <li class="px-0"><router-link :to="{name: 'home'}">Home</router-link></li>
            <li><router-link :to="{name: 'startstore'}">Start Store</router-link></li>
            <li><router-link :to="{name: 'home'}">Privacy Policy</router-link></li>
          </ul>
        </div>
      </div> -->
      <!-- Link list -->
      <div class="col-sm-12 col-md-12 m-auto">
        <div class="block block-info m-auto text-center">
          <h4>Contact Us</h4>
          <ul>
             <li><a><i class="fa fa-phone mr-2" aria-hidden="true"></i>011-360-1-444</a></li>
             <li><a><i class="fa fa-phone mr-2" aria-hidden="true"></i>0777-290-298</a></li>
            <li><a><i class="fa fa-envelope mr-2" aria-hidden="true"></i>info@eshops.lk</a></li>
          </ul>
            <ul class="social-media-icons mb-2  d-inline">
              <li style=""><a href="https://www.facebook.com/Eshopslk-2212428785713128/" class="px-0 ml-0 mr-2 "><i class="fa fa-facebook-official  f-sm-link" style="font-size:34px; color:#3b5998; background-color:#fff; width: 30px; height: 30px; border-radius: 4px; text-align: center; vertical-align: middle;"></i></a></li>
              <li><a href="https://www.instagram.com/eshops.lk/" class="px-0 mx-2"><i class="fa fa-instagram  f-sm-link " style="font-size:30px; color:#fff; background: #d6249f;
  background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%); width: 32px; height: 32px; border-radius: 4px; text-align: center; vertical-align: middle;"></i></a></li>
              <li><a href="https://www.youtube.com/channel/UCJhY3IfJD3T2bA5PJ3SrMZw" class="px-0 mx-2"><i class="fa fa-youtube-square  f-sm-link" style="font-size:35px; color:#FF0000;background-color:#fff; width: 30px; height: 30px; border-radius: 6px; text-align: center; vertical-align: middle;"></i></a></li>
            </ul>
        </div>
      </div>
      <!-- Promotion -->
     
    </div>
   
  </div>
     <div class="container mt-4">
      <div class="row">
        <div class="  col-12 mx-auto mt-2">
         
          <div class="copyright text-center">
            <img src="../../../static/img/eshops-logo.png" alt="eshops-logo">
            <p class="m-f-text mt-2">© 2018 eshops.lk | All Rights Reserved</p>
          </div>
        </div>
       
      </div>
    </div>
  <!-- Container End -->
</footer>
<!-- Footer Bottom -->
<footer class="">
    <!-- Container Start -->
   
    <!-- Container End -->
    <!-- To Top -->
  
</footer>
  <button class="goTop" v-if="isVisible" @click="backToTop">
        <i class="fa fa-angle-up" aria-hidden="true"></i>
    </button>
  </div>
</template>
<script>
export default {
  name:'adminfooter',
  data(){
      return{
          isVisible:false
      }
  }
}
</script>

<style scoped>
@import url('~@/assets/admin/css/footer.css');
</style>




// WEBPACK FOOTER //
// src/components/admin/AdminFooter.vue